
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail/[type]",
      function () {
        return require("private-next-pages/detail/[type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detail/[type]"])
      });
    }
  